import { MarketplacePlaceholder } from '../../components'

export default function MarketplaceModifiersPage() {
  return (
    <MarketplacePlaceholder
      title="Modifiers coming soon"
      description="Add-ons like extra cheese, size upgrades, and combo options will be available here."
      icon="🧩"
    />
  )
}
